const message = {
  "button.home.sendFiles": "Gửi tập tin",

  "button.options.record": "Ghi âm ngay bây giờ",
  "button.options.upload": "Chọn tập tin",
  "button.options.gallery": "Xem album",
  "button.options.bingoGame": "Bingo",
  "button.options.photoChallengeGame": "Thử thách ảnh",
  "button.options.quizGame": "Quiz",
  "button.options.teamMatchGame": "Team Match",
  "button.options.foodMenu": "Thực đơn",
  "button.options.schedule": "Lịch trình",
  "button.options.feed": "Dòng sự kiện",
  "message.options.bingoGame": "Chơi bingo của bữa tiệc!",
  "message.options.photoChallengeGame": "Tham gia thử thách ảnh!",
  "message.options.quizGame": "Kiểm tra kiến thức của bạn!",
  "message.options.teamMatchGame": "Bạn thuộc đội nào?",
  "message.options.foodMenu": "Xem thực đơn của bữa tiệc!",
  "message.options.schedule": "Kiểm tra lịch trình sự kiện!",
  "message.options.record": "Ghi lại thông điệp đặc biệt của bạn ngay bây giờ!",
  "message.options.upload":
    "Chia sẻ những bức ảnh và video đẹp nhất của bữa tiệc!",
  "message.options.gallery": "Xem ảnh của sự kiện!",
  "message.options.feed": "Theo dõi dòng thời gian của sự kiện!",

  "title.terms": "Điều khoản sử dụng",
  "title.notFound": "Rất tiếc, có vẻ như trang này không tồn tại.",
  "title.eventNotFound": "Lỗi truy cập sự kiện",

  "subtitle.goBackTo": "Quay lại",
  "subtitle.eventNotFound": "Sự kiện không tìm thấy hoặc đã hết hạn.",

  "message.termsOfUse":
    "Bằng cách sử dụng hệ thống của chúng tôi, bạn đồng ý với <code>Điều khoản sử dụng</code> của chúng tôi",
  "message.termsFirstParagraph":
    "Bằng cách sử dụng hệ thống tải lên ảnh và video của chúng tôi, bạn, với tư cách là khách tham dự sự kiện, đồng ý rằng chúng tôi thu thập và tải lên dữ liệu của bạn, bao gồm ảnh, video và thông tin cá nhân, đồng thời cung cấp dữ liệu đó cho người tổ chức sự kiện.",
  "message.termsSecondParagraph":
    "Chúng tôi không truy cập các tệp của bạn trừ khi được khách hàng yêu cầu cung cấp hỗ trợ kỹ thuật, giới hạn ở những gì cần thiết.",
  "message.termsThirdParagraph":
    "Công ty không chia sẻ dữ liệu với bên thứ ba và duy trì tính bảo mật thông tin, trừ khi pháp luật yêu cầu.",
  "message.shareLink":
    "Tạo một kỷ niệm đặc biệt! Nhanh chóng, dễ dàng và là một cách tuyệt vời để thể hiện tình yêu và sự quan tâm của bạn trong ngày này. Nhấp vào liên kết để bắt đầu ghi âm ngay bây giờ!",

  // recorder
  "button.recorder.understood": "Đã hiểu!",
  "button.recorder.close": "Đóng",
  "button.recorder.share": "Chia sẻ",
  "button.recorder.home": "Quay lại Màn hình chính",
  "button.recorder.back": "Quay lại",

  "title.recorder.permissionsToRecordAudioVideo": "Quyền Ghi âm",
  "title.recorder.success": "Thành công!",
  "title.recorder.uploading": "Đang tải lên",
  "title.recorder.alert": "Cảnh báo!",
  "title.recorder.saving": "Đang lưu",
  "title.recorder.waiting": "Đang chờ",
  "title.recorder.share": "Chia sẻ!",
  "title.recorder.error": "Lỗi!",
  "title.recorder.permissionCameraOrMicrophoneDenied": "Quyền không được cấp",
  "title.recorder.terms": "Điều khoản sử dụng",

  "subtitle.recorder.nextScreenClickAllow":
    "Trên màn hình tiếp theo, hãy nhấp vào <code>Cho phép</code>.",
  "subtitle.recorder.allowReinforcement":
    "Bạn cần nhấp vào <code>Cho phép</code> để ghi âm tin nhắn của bạn.",
  "subtitle.recorder.share": "Mời bạn bè của bạn cùng ghi âm!",
  "subtitle.recorder.dontRefreshPage":
    "Vui lòng không làm mới hoặc đóng trang này.",
  "subtitle.recorder.status.success":
    "Tin nhắn của bạn đã được ghi âm thành công!",
  "subtitle.recorder.browserNotSupported":
    "Trình duyệt của bạn không được hỗ trợ hoặc không được cấp quyền.",
  "subtitle.recorder.tryGrantPermission":
    "1. Làm mới trang và cho phép sử dụng máy ảnh.",
  "subtitle.recorder.tryAnotherBrowser":
    "2. Hãy thử sử dụng một trình duyệt khác như {chrome} hoặc {safari}.",
  "subtitle.recorder.mustLongerThan":
    "Tin nhắn phải dài hơn <code>5 giây</code>.",
  "subtitle.recorder.offline":
    "Bạn đang ngoại tuyến. Vui lòng kiểm tra kết nối của bạn.",
  "subtitle.recorder.startRecord": "Nhấp để bắt đầu ghi âm.",
  "subtitle.recorder.recording": "Đang ghi âm...",
  "subtitle.recorder.uploadError": "Lỗi tải lên video.",
  "subtitle.recorder.tryAgain": "Kiểm tra kết nối của bạn và thử lại.",
  "subtitle.recorder.permissionCameraOrMicrophoneDenied":
    "Không được cấp quyền máy ảnh/microphone",
  "subtitle.recorder.trySafariBrowser":
    "1. Sử dụng trình duyệt <code>SAFARI</code>",
  "subtitle.recorder.changeSiteSettingsUsingSafari":
    '2. Nhấp vào nút <code>"aA"</code> trong thanh URL và vào <code>"Cài đặt trang"</code>',
  "subtitle.recorder.grantCameraAndMicrophonePermissions":
    "3. <code>Cho phép</code> sử dụng máy ảnh và microphone",
  "subtitle.recorder.refreshPage": "4. Làm mới trang",
  "subtitle.recorder.tryChromeBrowser":
    "1. Sử dụng trình duyệt <code>CHROME</code>",
  "subtitle.recorder.changeSiteSettingsUsingChrome":
    '2. Truy cập cài đặt trang và nhấp vào <code>"Quyền"</code>',

  "message.recorder.almostDone": "Gần xong! Chỉ vài giây nữa thôi.",
  "message.recorder.sendingMessage":
    "Chia sẻ những khoảnh khắc yêu thích của bạn từ bữa tiệc!",

  "title.recorder.upload": "Tải lên",

  "subtitle.recorder.filesReadyToUpload": "Tệp sẵn sàng để tải lên:",

  "subtitle.recorder.fileWithError": "Tệp sẽ không được tải lên:",

  "message.recorder.fileSizeError": "Tệp vượt quá giới hạn kích thước cho phép",

  "button.recorder.send": "Gửi",

  "message.recorder.uploading": "Vui lòng không làm mới hoặc đóng trang này.",

  "message.recorder.uploadError": "Tải tệp lên thất bại.",

  "title.recorder.uploadFailure": "Tải lên thất bại",

  "title.recorder.completed": "Hoàn tất",

  "message.recorder.uploadComplete": "Tải lên thành công",

  "message.recorder.fileUploaded": "Tệp đã được tải lên thành công",

  "message.recorder.uploadFailed": "Không thể tải tệp lên",

  "message.recorder.checkYourConnectionAndTryAgain":
    "Vui lòng kiểm tra kết nối và thử lại",

  "button.recorder.ok": "OK!",

  "title.recorder.shareMoments": "Gửi tin nhắn của bạn",

  "subtitle.recorder.forThe1YearAnniversary": "Cho kỷ niệm 1 năm",

  "subtitle.recorder.now": "Cho bây giờ",

  "message.recorder.uploadMaxFilesLimit":
    "Chỉ tải lên <code>1 video</code> mỗi lần.",

  "message.recorder.uploadLimit": "Giới hạn tối đa:",

  "message.recorder.videoSizeLimit": "<code>800MB</code> mỗi video.",

  "button.recorder.send_video": "Gửi video",

  "message.recorder.uploadTip":
    "Nhấp vào nút bên trên và chọn video bạn vừa quay!",

  "title.recorder.guide.instructionsToRecord": "Hướng dẫn quay video",

  "subtitle.recorder.guide.instructions":
    "Mở <code>máy ảnh</code> trên thiết bị của bạn ở chế độ selfie và quay tin nhắn trong tối đa <code>2 phút</code>!",

  "subtitle.recorder.guide.moreInstructions":
    "Sau đó quay lại đây để gửi tin nhắn của bạn!",

  "message.recorder.instructions":
    "<code>Mở ứng dụng máy ảnh</code> trên thiết bị của bạn ở chế độ selfie và quay một tin nhắn dài tối đa <code>2 phút</code>!",
  "button.recorder.sendVideo": "Gửi video",
  "message.recorder.uploadTip.ios":
    "💡 Để có chất lượng tốt hơn, hãy chọn video từ thư viện ảnh",

  // uploader
  "button.uploader.send_photos": "Gửi ảnh",
  "button.uploader.send_video": "Gửi video",
  "button.uploader.close": "Đóng",
  "button.uploader.share": "Chia sẻ",
  "button.uploader.back": "Quay lại",
  "button.uploader.send": "Gửi",
  "button.uploader.continue": "Tiếp tục",
  "button.uploader.ok": "Được rồi",

  "title.uploader.success": "Thành công!",
  "title.uploader.uploading": "Đang tải lên",
  "title.uploader.alert": "Cảnh báo!",
  "title.uploader.saving": "Đang lưu",
  "title.uploader.waiting": "Đang chờ",
  "title.uploader.share": "Chia sẻ!",
  "title.uploader.error": "Lỗi!",
  "title.uploader.upload": "Tải lên",
  "title.uploader.shareMoments": "Chia sẻ khoảnh khắc",
  "title.uploader.uploadFailure": "Không thể tải lên",
  "title.uploader.completed": "Hoàn tất",
  "title.uploader.terms": "Điều khoản sử dụng",

  "subtitle.uploader.filesWithError":
    "Các tập tin <code>sẽ không được gửi</code>:",
  "subtitle.uploader.uploadHistory": "Các tập tin đã gửi",
  "subtitle.uploader.filesReadyToUpload": "Các tập tin sẵn sàng để tải lên:",

  "message.uploader.uploadMaxFilesLimit":
    "Gửi tối đa <code>50 ảnh hoặc 1 video</code> mỗi lần.",
  "message.uploader.uploadLimit": "Giới hạn tối đa:",
  "message.uploader.photoSizeLimit": "<code>20MB</code> mỗi ảnh",
  "message.uploader.videoSizeLimit": "<code>500MB</code> mỗi video",
  "message.uploader.fileSizeError": "Tập tin vượt quá kích thước cho phép.",
  "message.uploader.uploading": "Vui lòng không làm mới hoặc đóng trang này.",
  "message.uploader.uploadError": "Lỗi tải lên tập tin.",
  "message.uploader.maxFilesLimitError": "Chọn tối đa <code>50 ảnh</code>.",
  "message.uploader.notFoundFilesToUpload":
    "<code>Không tìm thấy tập tin để tải lên.</code>",
  "message.uploader.checkFileSizeAndTryAgain":
    "Kiểm tra <code>kích thước tập tin</code> và thử lại.",
  "message.uploader.uploadComplete": "Tải lên hoàn tất",
  "message.uploader.allFilesUploaded": "Tất cả các tập tin đã được tải lên",
  "message.uploader.nFilesUploaded": "{n} tập tin đã được tải lên",
  "message.uploader.nFilesNotUploaded": "{n} tập tin không thể tải lên",
  "message.uploader.noFilesUploaded": "Không có tập tin nào được tải lên",
  "message.uploader.checkYourConnectionAndTryAgain":
    "Kiểm tra kết nối của bạn và thử lại.",
  "message.uploader.uploadVerySlow":
    "Nếu tải lên chậm, hãy chọn một số ảnh mỗi lần",
  "message.uploader.uploadTip":
    "Để duy trì chất lượng tập tin, hãy tải lên từ thư viện thiết bị của bạn.",

  "title.guestForm": "Hồ Sơ Của Bạn",
  "placeholder.guestForm.name": "Tên hoặc biệt danh của bạn",
  "message.guestForm.nameRequired": "Tên là bắt buộc",
  "message.guestForm.dataInfo":
    "Dữ liệu được cung cấp không bắt buộc. Chúng sẽ chỉ hiển thị như một chữ ký trên các bức ảnh và video bạn gửi.",
  "button.guestForm.takePhoto": "Chụp một bức ảnh tự sướng (tùy chọn)",
  "button.guestForm.submit": "Lưu",
  "button.guestForm.uploading": "Đang lưu...",
  "button.guestForm.skip": "Tiếp tục ẩn danh",
  "message.cameraNotAvailable":
    "Không thể truy cập máy ảnh. Vui lòng đảm bảo rằng bạn đã cấp quyền truy cập máy ảnh.",
  "title.guestForm.cropPhoto": "Cắt ảnh",
  "button.guestForm.selectPhoto": "Chọn ảnh (tùy chọn)",

  "title.photoChallenge": "Thử Thách Ảnh",
  "subtitle.photoChallenge.tasks": "Nhiệm vụ",
  "subtitle.photoChallenge.done": "Hoàn thành",
  "message.photoChallenge.intro":
    "Mục tiêu là chụp ảnh theo chỉ dẫn trong mỗi mục tiêu.",
  "message.photoChallenge.todo": "Hoàn thành một thử thách",
  "message.photoChallenge.done": "Các thử thách đã hoàn thành",
  "button.photoChallenge.start": "Bắt đầu",

  "title.quiz": "Câu đố",
  "subtitle.quiz.intro": "Bạn có chấp nhận thử thách không?",
  "subtitle.quiz.result": "Kết quả",
  "message.quiz.intro":
    "Trong số tất cả các khách mời, hãy chứng minh rằng bạn là người hiểu rõ nhất về cặp đôi!",
  "button.quiz.start": "Bắt đầu",
  "button.quiz.confirm": "Xác nhận",
  "message.quiz.result":
    "Bạn đã trả lời đúng {score} trong số {totalQuestions} câu hỏi trong {time} giây",
  "message.quiz.saving": "Đang lưu...",
  "button.quiz.share": "Chia sẻ kết quả",
  "message.quiz.congrats": "🎉 Chúc mừng! 🎉",

  "message.bingo.intro":
    "Bạn có thể hoàn thành bingo trong khi vui chơi với mỗi thử thách không?",
  "button.bingo.start": "Bắt đầu",
  "label.bingo.fullCard": "Thẻ đầy đủ",
  "label.bingo.line": "Hàng",
  "label.bingo.firstColumn": "1 - Cột",
  "label.bingo.firstRow": "1 - Hàng",
  "subtitle.bingo.results": "Kết quả",
  "message.bingo.selectChallenge": "Nhấp để xem và hoàn thành thử thách",
  "button.bingo.removeChallenge": "Xóa thử thách",
  "button.bingo.continue": "Tiếp tục",
  "message.bingo.progress": "Tiếp tục hoàn thành các thử thách bingo!",
  "button.bingo.share": "Chia sẻ",

  "message.photoChallenge.intro.new":
    "Thật dễ dàng: làm theo hướng dẫn và vui chơi khi chụp ảnh!",
  "message.photoChallenge.inProgress.new":
    "Chọn một thử thách bên dưới và gửi ảnh của bạn.",
  "button.photoChallenge.share": "Chia sẻ kết quả",
  "message.photoChallenge.completed":
    "Bạn đã hoàn thành tất cả {total} thử thách ảnh!",
  "message.photoChallenge.congrats": "🎉 Chúc mừng! 🎉",

  "title.teamMatch": "Team Match",
  "subtitle.teamMatch.intro": "Khám phá đội của bạn",
  "subtitle.teamMatch.result": "Kết quả",
  "message.teamMatch.intro":
    "Làm bài kiểm tra và tìm hiểu xem bạn thuộc đội {teamA} hay đội {teamB}!",
  "button.teamMatch.start": "Bắt đầu",
  "button.teamMatch.next": "Tiếp theo",
  "message.teamMatch.result": "Đội của bạn là <code>{team}</code>!",
  "message.teamMatch.saving": "Đang lưu...",
  "button.teamMatch.share": "Chia sẻ kết quả",

  "feed.loading": "Đang tải nguồn cấp dữ liệu...",
  "feed.empty": "Chưa có mục nào trong nguồn cấp dữ liệu.",
  "feed.imageAlt": "Hình ảnh đã tải lên",
  "feed.anonymousGuest": "Khách ẩn danh",
  "feed.imageUploader.title": "Ảnh Đã Tải Lên",

  "feed.quiz.title": "Câu Đố",
  "feed.quiz.description":
    "{guestName} đã hoàn thành câu đố! Kết quả: {score}/{total} trong {time} giây",
  "feed.photoChallenge.title": "Thử Thách Ảnh",
  "feed.photoChallenge.description":
    "{guestName} đã hoàn thành thử thách: {challenge}",
  "feed.teamMatch.title": "Team Match",
  "feed.teamMatch.description":
    "{guestName} đã tham gia Team Match. Kết quả: {teamAName} {scoreA} x {scoreB} {teamBName}",
  "feed.newGuest.title": "Khách Mới",
  "feed.newGuest.description": "{guestName} đã tham gia sự kiện",
  "feed.videoRecorder.title": "Tin Nhắn Mới",
  "feed.videoRecorder.description": "{guestName} đã gửi một tin nhắn mới",
  "feed.default.title": "Hoạt Động",
  "feed.default.description": "Một hoạt động mới đã xảy ra",

  "feed.ctaPost.ctaButton":
    "Bạn đang thích sự kiện này? Hãy đăng một bức ảnh nữa!",
  "feed.imageUploader.description":
    "{guestName} đã tải tệp lên thư viện của bữa tiệc",
  "feed.cdt-imageUploader.title": "Tin nhắn mới",
  "feed.cdt-imageUploader.description":
    "{guestName} đã tải tệp lên cho Kỷ niệm 1 năm!",
  "feed.quiz.ctaButton": "Kiểm tra kiến thức của bạn",
  "feed.photoChallenge.ctaButton": "Tham gia thử thách nữa",
  "feed.teamMatch.ctaButton": "Tham gia Team Match",
  "feed.videoRecorder.ctaButton": "Ghi lại một tin nhắn ngay bây giờ",
  "feed.videoUploader.title": "Tin nhắn mới",
  "feed.videoUploader.description":
    "{guestName} đã tải một video lên thư viện của bữa tiệc",
  "feed.cdt-videoUploader.title": "Tin nhắn mới",
  "feed.cdt-videoUploader.description":
    "{guestName} đã tải một video lên cho Kỷ niệm 1 năm!",
  "feed.newPost.title": "Bài đăng mới",
  "feed.cdtVideoRecorder.description":
    "<code>{guestName}</code> đã để lại một tin nhắn cho <code>Kỷ niệm 1 năm!</code>",
  "feed.cdtVideoRecorder.ctaButton": "Hãy làm điều tương tự!",
  "feed.placeholder.newPost": "Tạo bài đăng...",
  "feed.placeholder.newPostMessage": "Viết tin nhắn của bạn...",

  "feed.menu.title.interaction": "Gửi tệp",
  "feed.menu.button.options.newPost": "Tạo bài đăng",
  "feed.menu.message.options.newPost": "Tạo bài đăng ngay bây giờ!",
  "feed.menu.button.options.record": "Ghi lại ngay",
  "feed.menu.message.options.record":
    "Ghi lại tin nhắn đặc biệt của bạn ngay bây giờ!",
  "feed.menu.button.options.upload": "Chọn tệp",
  "feed.menu.message.options.upload":
    "Chia sẻ những bức ảnh và video đẹp nhất từ bữa tiệc!",
  "feed.menu.title.gallery": "Thư viện của bữa tiệc",
  "feed.menu.button.options.gallery": "Xem album",
  "feed.menu.message.options.gallery": "Xem ảnh của sự kiện!",
  "feed.menu.title.games": "Trò chơi",
  "feed.menu.button.options.bingoGame": "Bingo",
  "feed.menu.message.options.bingoGame": "Chơi bingo của bữa tiệc!",
  "feed.menu.button.options.photoChallengeGame": "Thử thách ảnh",
  "feed.menu.message.options.photoChallengeGame": "Tham gia thử thách ảnh!",
  "feed.menu.button.options.quizGame": "Đố vui",
  "feed.menu.message.options.quizGame": "Kiểm tra kiến thức của bạn!",
  "feed.menu.button.options.teamMatchGame": "Team Match",
  "feed.menu.message.options.teamMatchGame": "Bạn thuộc về đội nào?",
  "feed.menu.title.info": "Về sự kiện",
  "feed.menu.button.options.foodMenu": "Thực đơn",
  "feed.menu.message.options.foodMenu": "Xem thực đơn của bữa tiệc!",
  "feed.menu.button.options.schedule": "Lịch trình",
  "feed.menu.message.options.schedule": "Xem lịch trình của bữa tiệc!",
  "feed.menu.title.guestInfo": "Thông tin của bạn",
  "feed.menu.options.anonymousGuest": "Khách ẩn danh",
  "feed.menu.options.guestEditInfo": "Bấm để chỉnh sửa thông tin của bạn!",
  "feed.menu.title.other": "Khác",
  "feed.menu.button.options.language": "Ngôn ngữ",
  "feed.menu.message.options.languageInfo": "Bấm để thay đổi ngôn ngữ!",
  "feed.button.options.cancel": "Hủy",
  "feed.button.options.confirm": "Xác nhận",
  "feed.menu.button.options.share": "Chia sẻ",
  "feed.menu.message.options.shareInfo": "Chia sẻ liên kết sự kiện!",
  "feed.menu.button.options.about": "Về Time Capsule",
  "feed.menu.message.options.about": "Tìm hiểu thêm về Time Capsule!",
  "feed.createPost.title": "Bài đăng mới",
  "feed.button.creatingPost": "Đang đăng...",
  "feed.button.createPost": "Đăng",
  "feed.editImage.title": "Chỉnh sửa ảnh",
  "feed.newPost.selectImage": "Chọn ảnh",
  "feed.createPost.info.sendingPostImage": "Đang gửi ảnh...",
  "feed.createPost.info.creatingPost": "Đang tạo bài đăng...",
  "feed.createPost.info.finalizingPost": "Đang hoàn tất...",
  "feed.menu.button.options.games": "Trò chơi",
  "feed.modalGames.title": "Trò chơi trong bữa tiệc",
  "feed.bingo.result.line": "Hàng",
  "feed.bingo.result.column": "Cột",
  "feed.bingo.result.fullCard": "Toàn bộ thẻ",
  "feed.bingo.title": "Bingo",
  "feed.bingo.description":
    "{guestName} đã hoàn thành một {challenge} trong trò bingo",
  "feed.bingo.ctaButton": "Chơi bingo ngay nào",
  "feed.deletePost.title": "Xóa bài đăng",
  "feed.deletePost.message":
    "Bạn có chắc chắn muốn xóa bài đăng này không? Hành động này không thể hoàn tác.",

  "title.uploader.modalMixedEventTitle":
    "KHI NÀO bạn muốn cô dâu chú rể nhận được ảnh hoặc video của bạn?",
  "button.options.sendNow": "Gửi ngay",
  "message.options.sendNow":
    "Cô dâu chú rể sẽ có quyền truy cập vào các tệp ngay lập tức!",
  "button.options.sendLater": "Vào dịp kỷ niệm 1 năm ngày cưới",
  "message.options.sendLater": "Gửi vào 'Hộp Thời Gian' của sự kiện!",

  "button.cancel": "Hủy",
  "button.delete": "Xóa",
  "button.quiz.continue": "Tiếp tục",
  "button.recorder.recorder.back": "Quay lại",
  "button.teamMatch.continue": "Tiếp tục",
  "cropper.remove.frame": "Xóa khung",
  "cropper.use.frame": "Sử dụng khung",
  "error.guestForm.fileTooLarge": "Tệp phải có kích thước tối đa 10MB",
  "error.guestForm.invalidFileType": "Vui lòng chọn một tệp hình ảnh hợp lệ",
  "error.guestForm.removePhotoFailed": "Không thể xóa ảnh. Vui lòng thử lại.",
  "error.guestForm.saveFailed": "Lưu thất bại. Vui lòng thử lại.",
  "error.guestForm.updateFailed": "Lưu thất bại. Vui lòng thử lại.",
  "error.guestForm.uploadFailed": "Tải ảnh lên thất bại. Vui lòng thử lại.",
  "title.guestForm.unsavedChanges": "Thay đổi chưa được lưu",
  "message.guestForm.unsavedChanges":
    "Bạn có thay đổi chưa được lưu. Bạn có muốn thoát mà không lưu?",
  "button.guestForm.cancel": "Hủy",
  "button.guestForm.exitWithoutSaving": "Thoát mà không lưu",
  "message.bingo.remove.warning":
    "Khi xóa thử thách này, kết quả của bạn sẽ được tính lại.",
  "message.bingo.remove.warning.detail1":
    "Các hàng và cột bị ảnh hưởng bởi việc xóa sẽ được xem xét lại.",
  "message.bingo.remove.warning.detail2":
    "Nếu có các thành tựu hoàn thành khác, thời gian sẽ được cập nhật đến thời điểm hiện tại.",
  "message.guest.nameRequired": "Tên là bắt buộc",
  "message.quiz.progress":
    "Câu đố vẫn đang diễn ra! Tiếp tục và thể hiện khả năng của bạn!",
  "message.teamMatch.progress":
    "Trò chơi vẫn đang diễn ra! Tiếp tục và khám phá đội của bạn!",
  "title.feed": "Dòng sự kiện",
};

export default message;
